import eventListeners from '../../hdrm/listeners/event-listeners';

const add = (element, eventName, ...attributes) => {
  const listenerId = eventListeners.add(element, eventName, ...attributes);

  return eventListeners.removeById.bind(this, element, eventName, listenerId);
};

export default {
  add,
};
